// @ts-strict-ignore
import { Typography } from '@mui/material';
import { useAssetClassMetaV2 } from 'phoenix/models/AssetClasses/useAssetClass';
import { useSecurityMetadataV2 } from 'phoenix/stores/SecurityMetadataV2Store';
import { ChangeColor, FormatNumber } from 'phoenix/util';
import { XS } from 'phoenix/xstream/XS';
import React from 'react';
import { DirectionalArrow, Flex } from '../..';
import style from '../style.module.scss';

interface SecurityValueProps {
    symbol: string;
    chartPercChange?: number;
    chartPrice?: number;
    decimalPlaces?: number;
    withQuoteOverride?: boolean;
}

export const SecurityValue = React.memo((props: SecurityValueProps) => {
    const { symbol } = props;
    const quote = XS.Quotes.use(props.symbol);
    const price = quote?.price || props.chartPrice;
    const percChange = props.withQuoteOverride ? quote?.changePercent || props.chartPercChange || null : props.chartPercChange || null;
    const meta = useSecurityMetadataV2().getMetadataBySymbol(symbol);
    const { formatPrice } = useAssetClassMetaV2(symbol);
    const formattedPrice = formatPrice(price, meta);

    return (
        <Flex column className={style.pricingColumn}>
            <Typography variant='h6'>{formattedPrice}</Typography>
            {!isNaN(percChange) ? (
                <Flex align='center' justify='flex-end'>
                    <DirectionalArrow height={8} valueChange={percChange} />
                    <Typography style={{ paddingLeft: '5px', color: ChangeColor(percChange) }} variant='body1'>
                        {FormatNumber.toPercent(percChange * 100, 'never')}
                    </Typography>
                </Flex>
            ) : (
                <Typography className={ChangeColor(0)} style={{ paddingLeft: '5px' }} variant='body1'>
                    {FormatNumber.toPercent(0, 'never')}
                </Typography>
            )}
        </Flex>
    );
});
